<script lang="ts">
	import { WIDGET_TYPE_DEBUG_ENTRIES } from 'src/helpers/dev/widgetTypeDebug';
	import {
		setWidgetTypeOutlinesEnabled,
		widgetTypeOutlinesEnabled,
	} from 'src/stores/features/dev/widget-type-outlines';
</script>

{#if $widgetTypeOutlinesEnabled}
	<aside class="widget-type-debug-legend" aria-label="Dashboard widget type colors">
		<div class="widget-type-debug-legend-head">
			<strong>Widget types</strong>
			<button type="button" onclick={() => setWidgetTypeOutlinesEnabled(false)}>Hide</button>
		</div>
		<ul>
			{#each WIDGET_TYPE_DEBUG_ENTRIES as [type, meta] (type)}
				<li>
					<span class="swatch" style:background={meta.color}></span>
					<span>{meta.label}</span>
				</li>
			{/each}
		</ul>
	</aside>
{/if}

<style>
	.widget-type-debug-legend {
		position: fixed;
		right: 16px;
		bottom: 16px;
		z-index: 2147482000;
		width: 220px;
		max-height: min(70vh, 520px);
		overflow: auto;
		padding: 10px 12px;
		border-radius: 10px;
		background: rgba(17, 17, 17, 0.88);
		color: #fff;
		box-shadow: 0 8px 24px rgba(0, 0, 0, 0.28);
		font-size: 11px;
		line-height: 1.3;
	}

	.widget-type-debug-legend-head {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 8px;
		margin-bottom: 8px;
	}

	.widget-type-debug-legend-head strong {
		font-size: 11px;
		letter-spacing: 0.04em;
		text-transform: uppercase;
	}

	.widget-type-debug-legend-head button {
		border: 0;
		background: transparent;
		color: #cbd5e1;
		cursor: pointer;
		font: inherit;
		padding: 0;
	}

	ul {
		margin: 0;
		padding: 0;
		list-style: none;
		display: grid;
		gap: 4px;
	}

	li {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.swatch {
		width: 10px;
		height: 10px;
		border-radius: 999px;
		flex: 0 0 auto;
	}
</style>
